/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'

export function findManyPayments (params: Record<string, any>): Promise<{ data: Payment[] }> {
  return rest.get(`/api/payments?${stringify(params)}`)
    .then((resp) => resp.json())
}
